var data = { header:{ text:"#### Warning",
    closeButton:true },
  body:{ text:"The combination of selected tests is not supported. If you wish to add this test you will need to remove RNA analysis.\n\nDo you want to remove RNA analysis and add this test?" },
  buttons:[ { text:"Yes add this test",
      isPrimary:true,
      action:"clearRnaAnalysisAndAddConcepts" },
    { text:"No keep my current order",
      isPrimary:false,
      action:"keepOrder" } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=diagnostic_rna_other_rrs_combo_error.esm.js.map
